import api from './api';

export interface UserRole {
  id: number;
  name: string;
}

export interface UserFirm {
  id: number;
  name: string;
  status?: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  is_approved: boolean;
  registration_completed: boolean;
  firm?: UserFirm | null;
  roles: UserRole[];
  created_at: string;
}

export interface CreateUserPayload {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
  firm_id?: number | null;
  roles?: string[];
  is_approved?: boolean;
}

export interface UpdateUserPayload {
  name?: string;
  email?: string;
  password?: string;
  password_confirmation?: string;
  firm_id?: number | null;
  roles?: string[];
  is_approved?: boolean;
}

export const userService = {
  getUsers: () => api.get<{ data: User[] }>('/admin/users'),
  getUser: (id: number) => api.get<{ data: User }>(`/admin/users/${id}`),
  createUser: (payload: CreateUserPayload) =>
    api.post<{ data: User; message: string }>('/admin/users', payload),
  updateUser: (id: number, payload: UpdateUserPayload) =>
    api.put<{ data: User; message: string }>(`/admin/users/${id}`, payload),
  deleteUser: (id: number) => api.delete(`/admin/users/${id}`),
};
